import { readonly, ref } from 'vue'

let resolveConfirmation: (() => void) | null = null
let rejectConfirmation: (() => void) | null = null

const isVisible = ref(false)

const resetConfirmation = () => {
  resolveConfirmation = null
  rejectConfirmation = null
}

const confirmPauseCreation = () =>
  new Promise<void>((resolve, reject) => {
    resolveConfirmation = resolve
    rejectConfirmation = reject
    isVisible.value = true
  })

const acceptPauseCreation = () => {
  resolveConfirmation?.()
  isVisible.value = false
  resetConfirmation()
}

const rejectPauseCreation = () => {
  rejectConfirmation?.()
  isVisible.value = false
  resetConfirmation()
}

export const usePauseCreateConfirmDialog = () => ({
  isVisible: readonly(isVisible),
  confirmPauseCreation,
  acceptPauseCreation,
  rejectPauseCreation,
})
